/**
 * deeplink.js — frontend-tarafı ayna doğrulama.
 *
 * Backend (services/notify.py::is_safe_internal_deeplink — bkz. reviewer
 * open-redirect/scheme-injection bulgusu 2026-07-23) admin toplu bildirim
 * `deeplink` alanına aynı kuralı Pydantic validator olarak uyguluyor
 * (routes/admin_bulk.py::BulkNotifyPayload.valid_deeplink, geçersizse 422).
 * Bu fonksiyon AYNI kuralı frontend'de tekrarlar — SADECE erken/anlaşılır
 * bir uyarı göstermek için (UX), backend doğrulamasının YERİNE GEÇMEZ.
 *
 * Security audit ORTA bulgu (2026-07-23 — backslash bypass): WHATWG URL
 * normalizasyonunda `\` özel şemalarda (http/https/ws/...) `/` ile
 * EŞDEĞERDİR — yani "/\evil.com" eski kuralda ('/' ile başlıyor, '//' ile
 * başlamıyor, ':' içermiyor) GEÇİYORDU ama tarayıcı/`new URL()` bunu fiilen
 * "//evil.com" (protocol-relative open redirect) olarak yorumluyor. Backend
 * bu bypass'ı kapattı (bkz. backend/services/notify.py::
 * is_safe_internal_deeplink); bu fonksiyon AYNI düzeltilmiş kuralla
 * eşitlenmiştir — frontend ile backend kuralı AYRIŞIRSA ya frontend'in kabul
 * edip backend'in reddettiği (admin yazar, gönderemez) ya da tersi
 * (frontend engelliyor, backend izin veriyor) durum oluşur; bu iki kod yolu
 * birebir aynı satırlarla tutulmalı (bkz. deeplink.test.js senkronizasyon
 * yorumu).
 *
 * Kural (hepsi sağlanmalı):
 *   - '/' ile başlamalı (uygulama-içi path)
 *   - ikinci karakter '/' VEYA '\' OLMAMALI (protocol-relative URL — örn.
 *     "//evil.com/x", "/\evil.com", "\\evil.com" — WHATWG URL
 *     normalizasyonunda `\` == `/`)
 *   - ':' İÇERMEMELİ (scheme injection — örn. "javascript:...", "https://...")
 *
 * Boş string GEÇERLİ sayılır (opsiyonel alan — kullanıcı hiç bağlantı
 * eklememiş demektir, çağıran taraf bunu "gönderme" olarak ele almalı).
 */
export function isSafeInternalDeeplink(value) {
  if (!value) return true;
  if (!value.startsWith('/')) return false;
  if (value.includes(':')) return false;
  if (value.length >= 2 && (value[1] === '/' || value[1] === '\\')) return false;
  return true;
}
